import { c as _c } from "react/compiler-runtime";
import { classNames, Flex, FlexColumn, SkeletonBlock, SkeletonLine, TextLabel } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { useTranslations } from "next-intl";
import { slideClasses } from "@/components/collection/overview/styles";
export function FeaturedCollectionsCarouselSkeleton(t0) {
  const $ = _c(5);
  const {
    slides
  } = t0;
  const t = useTranslations("FeaturedCollectionsCarousel");
  let t1;
  if ($[0] !== slides || $[1] !== t) {
    let t2;
    if ($[3] !== t) {
      t2 = index => <FlexColumn className={classNames("h-full overflow-hidden rounded-xl bg-primary", slideClasses())} key={index}><SkeletonBlock className="relative aspect-16/9 w-full rounded-b-none bg-bg-additional-2" /><div className="flex-1 p-4 lg:p-6"><SkeletonLine className="h-6 w-1/2" /><Flex className="mt-4 justify-between"><FlexColumn className="basis-1/2 gap-1"><TextLabel className="text-text-secondary">{t("floorPrice")}</TextLabel><SkeletonLine className="h-6 w-1/2" /></FlexColumn><FlexColumn className="basis-1/2 items-end gap-1"><TextLabel className="text-text-secondary">{t("totalVolume")}</TextLabel><SkeletonLine className="h-6 w-1/2" /></FlexColumn></Flex></div></FlexColumn>;
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = range(slides).map(t2);
    $[0] = slides;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}